import { render, staticRenderFns } from "./GraffidiApplicativiListComponent.vue?vue&type=template&id=513ad56f"
import script from "./GraffidiApplicativiListComponent.vue?vue&type=script&lang=js"
export * from "./GraffidiApplicativiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports